import {
  Activity,
  AlertCircle,
  BarChart3,
  Bell,
  Calendar,
  Check,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Flame,
  Focus,
  Home,
  Image,
  Info,
  Loader2,
  LogOut,
  MapPin,
  Medal,
  MessageCircle,
  Monitor,
  Moon,
  Pencil,
  Plus,
  QrCode,
  RefreshCw,
  Search,
  Settings,
  Share2,
  Download,
  Shield,
  SlidersHorizontal,
  Sparkles,
  Sun,
  Target,
  Trophy,
  TrendingUp,
  UserRound,
  Users,
  WifiOff,
  X,
  Zap,
  MoreHorizontal,
} from "lucide-react";
import { iconSizes } from "../tokens/iconSizes";

/** Lucide-backed icons (Design Language v1.0 §8). */
const LUCIDE_ICONS = {
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  plus: Plus,
  check: Check,
  close: X,
  search: Search,
  home: Home,
  image: Image,
  info: Info,
  loader: Loader2,
  refresh: RefreshCw,
  alert: AlertCircle,
  settings: Settings,
  flame: Flame,
  focus: Focus,
  barChart: BarChart3,
  bell: Bell,
  users: Users,
  trophy: Trophy,
  medal: Medal,
  message: MessageCircle,
  monitor: Monitor,
  moon: Moon,
  pencil: Pencil,
  qrCode: QrCode,
  share: Share2,
  download: Download,
  shield: Shield,
  signOut: LogOut,
  sliders: SlidersHorizontal,
  sun: Sun,
  user: UserRound,
  activity: Activity,
  calendar: Calendar,
  mapPin: MapPin,
  sparkles: Sparkles,
  target: Target,
  zap: Zap,
  trendingUp: TrendingUp,
  moreHorizontal: MoreHorizontal,
  wifiOff: WifiOff,
};

export const TRA_ICON_NAMES = Object.freeze(Object.keys(LUCIDE_ICONS));

/**
 * Icon primitive — Lucide stroke icons sized via design tokens.
 */
export default function TRAIcon({
  name,
  size = "md",
  strokeWidth,
  color = "currentColor",
  title,
  className,
  ...rest
}) {
  const Icon = LUCIDE_ICONS[name];
  if (!Icon) return null;
  const px = iconSizes[size] ?? iconSizes.md;
  const stroke = strokeWidth ?? (px >= iconSizes.lg ? 2 : 1.75);
  return (
    <Icon
      size={px}
      strokeWidth={stroke}
      color={color}
      className={className}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      role={title ? "img" : undefined}
      {...rest}
    />
  );
}

export { LUCIDE_ICONS };
